import {EventSourceContainer} from './components/event-source-container';

export default {
    component: EventSourceContainer
};
